// src/context/NotificationItems.js
import React, { createContext, useState } from "react";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  // NotificationItems.js
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      message:
        "Your order has been shipped have a nice dayyyyyyyyyyy fasdfadfasdfasdfsdfasfadfaadf",
      timestamp: "11/06/2025 10:00 AM",
    },
    {
      id: 2,
      message: "New assignment uploaded",
      timestamp: "11/06/2025 09:30 AM",
    },
    {
      id: 3,
      message: "Meeting rescheduled to 3 PM",
      timestamp: "10/06/2025 04:45 PM",
    },
    {
      id: 4,
      message: "Fee payment successful",
      timestamp: "10/06/2025 01:15 PM",
    },
    {
      id: 5,
      message: "System maintenance tonight",
      timestamp: "09/06/2025 07:00 PM",
    },
  ]);
  return (
    <NotificationContext.Provider value={{ notifications, setNotifications }}>
      {children}
    </NotificationContext.Provider>
  );
};
